import { render, staticRenderFns } from "./common-steps.vue?vue&type=template&id=539a459c&scoped=true&"
import script from "./common-steps.vue?vue&type=script&lang=js&"
export * from "./common-steps.vue?vue&type=script&lang=js&"
import style0 from "./common-steps.vue?vue&type=style&index=0&id=539a459c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539a459c",
  null
  
)

export default component.exports